import changeCities from './../modules/Utils/changeCities';

changeCities();

$("#profissao").on('change', function() {
    if ($(this).val() == 'Enfermeiro') {
        $("#registry_area").removeAttr('disabled');
        $("#registry_number").removeAttr('disabled');
        $("#registry_state").removeAttr('disabled');
        $("#registry_area").removeAttr('notRequired');
        $("#registry_number").removeAttr('notRequired');
        $("#registry_state").removeAttr('notRequired');
        $("#registry_area").val('COFEN').trigger('change');
    } else if($(this).val() == 'Farmacêutico') {
        $("#registry_area").removeAttr('disabled');
        $("#registry_number").removeAttr('disabled');
        $("#registry_state").removeAttr('disabled');
        $("#registry_area").removeAttr('notRequired');
        $("#registry_number").removeAttr('notRequired');
        $("#registry_state").removeAttr('notRequired');
        $("#registry_area").val('CRF').trigger('change');
    } else {
        $("#registry_area").val('').trigger('change');
        $("#registry_area").attr('disabled', 'disabled');
        $("#registry_state").attr('disabled', 'disabled');
        $("#registry_number").attr('disabled', 'disabled');
        $("#registry_area").attr('notRequired', '1');
        $("#registry_state").attr('notRequired', '1');
        $("#registry_number").attr('notRequired', '1');
    }
});
